// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bordetitulo {
  height: 1px;
  width: 100%;
  background-color: #450d1c;
}

td {
  word-wrap: break-word;
}

.dbindiceview {
  word-wrap: break-word;
}

button.mat-icon-button:first-child:hover:after {
  position: absolute;
  right: 100%;
  border-radius: 3px;
  content: "FIELDS";
  background: rgb(187, 187, 187);
  padding: 4px;
  top: -3px;
}

p-table {
  width: 100%;
}

.form-row-internal {
  margin-bottom: 15px;
}

.full-width-internal {
  width: 100%;
}

.info-grid-internal {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 15px;
}

.info-item-internal {
  flex: 1 1 calc(25% - 20px);
  min-width: 220px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
